export const FORBIDDEN_CHATS_NAME_LIST = ["Facebook Example", "Twitter Example"];